export default __webpack_public_path__ + "static/media/news3.e4619be2.png";